module.exports = __webpack_public_path__ + "static/media/add_customer.7ec3ae4e.png";